import { forwardRef, type HTMLAttributes } from "react";

/**
 * การ์ดมาตรฐาน (MASTER §2) — ขอบมน + เส้นขอบ + พื้นขาว + เงา ink
 *
 * - `CARD_BASE_CLS` ไม่มี padding — ใช้กับ element อื่นที่ไม่ใช่ div (section/details/button)
 *   หรือการ์ดที่ padding ต่างจากมาตรฐาน (ตาราง = ไม่มี padding, ฟอร์ม modal = p-6)
 * - `CARD_CLS` = การ์ดมาตรฐาน padding p-5
 * - `<Card>` = div การ์ด · `padding` แทน p-5 ได้ (ส่ง "" = ไม่มี padding) · `className` ต่อท้าย
 *   (อย่าส่ง padding ผ่าน className — class p-* สองตัวชนกัน ผลขึ้นกับลำดับใน CSS)
 */
export const CARD_BASE_CLS = "rounded-2xl border border-border bg-surface-raised shadow-card";
export const CARD_CLS = `${CARD_BASE_CLS} p-5`;

type Props = HTMLAttributes<HTMLDivElement> & {
  /** class padding ของการ์ด (ค่าเริ่มต้น "p-5") */
  padding?: string;
};

export const Card = forwardRef<HTMLDivElement, Props>(function Card(
  { padding = "p-5", className = "", ...rest },
  ref
) {
  const cls = [CARD_BASE_CLS, padding, className].filter(Boolean).join(" ");
  return <div ref={ref} className={cls} {...rest} />;
});
